module.exports = __webpack_public_path__ + "static/img/address.cb32177a.png";